<script lang="ts">
    import { Card, Col, Image } from "sveltestrap";
    import User from "../../../Data/ComponentData/DashboardData/EcommerceData/TopDealer.json";
    import Carousel from "svelte-carousel";
    import Link from "svelte-link";
    import { href, ViewMore } from "../../../utils/Constant/Constant";
    let imgPath : string= '/assets/images/dashboard-2';
    let carousel:any;
    let y:number ,x:number, z:number
    const handleCarousel = (value:number) =>{
      if(value <= 480){
          x = 2
      }else{
        if(value <= 1670){
           x = 3
        }else{
            x = 4
        }
      }
      return x
    }
    const handleScroll = (value:number) => {
      if(value <= 480){
         z = 2
      }else{
        if(value <= 1670){
          z = 3
        }else{
           z = 4
        }
      }
      return z
    }
</script>
<svelte:window bind:innerWidth={y}/>
{#each User.Topdealer as Userdata}
    <Col>
        <div class="owl-carousel-16 owl-carousel owl-theme">
            <Carousel
                bind:this={carousel}
                particlesToShow={handleCarousel(y)}
                particlesToScroll={handleScroll(y)}
                arrows={false}
                dots={false}
            >
                {#each Userdata.User1 as userItem}
                    <div class="item me-2">
                        <Card>
                            <div class="top-dealerbox text-center">
                                <Image
                                    class="card-img-top"
                                    src={`${imgPath}/${userItem.src}`}
                                    alt="..."
                                />
                                <h6>{userItem.name}</h6>
                                <p>{userItem.place}</p>
                                <Link
                                    class="btn btn-rounded"
                                    href={href}
                                    >{ViewMore}
                                </Link>
                            </div>
                        </Card>
                    </div>
                {/each}
            </Carousel>
        </div>
    </Col>
{/each}
